import React from 'react';
import { GoogleMap, LoadScript  } from '@react-google-maps/api';
import {MAP_KEY} from '../keys';

function Map(props) {
  const [map, setMap] = React.useState(null);
  const [currentLoc, setCurrentLoc] = React.useState({
    lat: 42.331429,
    lng: -83.045753,
  });

  const onLoad = React.useCallback(function callback(map) {
    setMap(map);

    setInterval((props) => {
      //console.log("refreshed");
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          setCurrentLoc({
            lat: this.props.latitud,
            lng: this.props.longitud,
          });
        });
      }
    }, 2000); 
  }, []);

  return (
    <LoadScript googleMapsApiKey={ MAP_KEY } >
      <GoogleMap        
        mapContainerStyle={{ width: '100%', height: '50vh' }}
        center={{ lat: props.latitud, lng: props.longitud }}
        zoom={10}
        onLoad={onLoad}
      >
        <></>
      </GoogleMap>
    </LoadScript>
  );
}

export default React.memo(Map);


